/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const selectSurvey = state => state.survey;
